var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"titlePhoto"},[_c('v-img',{attrs:{"dark":"","alt":"Illustrated resting cat","lazysrc":"","contain":"","height":"200","width":"300","src":require('../assets/imgs/kitty.png')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }